import { useTranslation } from 'react-i18next';

import SaveIcon from '@mui/icons-material/Save';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

export const LoaderButtonTypes = {
  Create: 'create',
  Save: 'save',
  Upload: 'upload',
};

export const getFormContainerSX = (
  isSubmitting = false,
  type = LoaderButtonTypes.Create,
  defaultStyle = {},
) => {
  if (!isSubmitting) return defaultStyle;

  switch (type) {
    case LoaderButtonTypes.Create:
    case LoaderButtonTypes.Save:
      return { opacity: '40%', pointerEvents: 'none', ...defaultStyle };

    case LoaderButtonTypes.Upload:
      return { opacity: '30%', pointerEvents: 'none', ...defaultStyle };

    default:
      return defaultStyle;
  }
};

const LoaderButton = ({
  isSubmitting = false,
  isValid = true,
  onClick = () => {},
  startIcon = <SaveIcon />,
  variant = 'outlined',
  dataTestId = 'save-btn',
  buttonSx = {},
  circularProgressSx = {},
  circularColor = 'primary',
  sizeCircularProgress = 25,
  submitText = 'saving',
  defaultText = 'save_button',
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <Button
      data-test-id={dataTestId}
      variant={variant}
      disabled={!isValid || isSubmitting}
      onClick={isSubmitting ? () => {} : onClick}
      startIcon={isSubmitting ? null : startIcon}
      sx={{ ...buttonSx, pointerEvents: isSubmitting ? 'none' : 'auto' }}
      {...rest}
    >
      {isSubmitting && (
        <CircularProgress
          color={circularColor}
          size={sizeCircularProgress}
          sx={{ margin: '0 10px 0 0', ...circularProgressSx }}
        />
      )}
      <Typography sx={{ minWidth: '60px' }}>
        {isSubmitting ? t(submitText) : t(defaultText)}
      </Typography>
    </Button>
  );
};

export default LoaderButton;
